import { derived } from 'overmind';
import { ContinueWatchingStatus } from '#types';

export type ContinueWatchingItem = {
  id: string;
  currentTime: number;
  mediaDuration: number;
  mediaIri: string;
  seriesIri: string;
  createdAt: string;
  modifiedAt?: string;
  state?: ContinueWatchingStatus;
};

type State = {
  items: ContinueWatchingItem[];
  itemMap: { [key: string]: ContinueWatchingItem };
  itemIriList: string[];
  itemsInProgress: string[];
};

export const state: State = {
  items: [],
  itemMap: derived((_state: State) => {
    return _state.items.reduce((res, value) => {
      res[value.mediaIri] = value;
      return res;
    }, {});
  }),
  itemIriList: derived((_state: State) => {
    return _state.items.map((value) => value.mediaIri);
  }),
  itemsInProgress: derived((_state: State) => {
    return _state.items
      .filter((item) => item.state === ContinueWatchingStatus.WATCHING)
      .map((item) => item.mediaIri);
  }),
};
